import React from "react";
import { Link } from "react-router-dom";

export default function MothersDayPromo() {
  return (
    <div className="mothers-day-promo" aria-label="Mother's Day Weekend Specials">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Outfit:wght@400;600;700&display=swap');

        @keyframes mdpFlutter1 {
          0%   { transform: translate(0, 0) rotate(-8deg); }
          25%  { transform: translate(20vw, -40px) rotate(8deg); }
          50%  { transform: translate(40vw, -10px) rotate(-6deg); }
          75%  { transform: translate(60vw, -50px) rotate(10deg); }
          100% { transform: translate(85vw, -20px) rotate(-8deg); }
        }
        @keyframes mdpFlutter2 {
          0%   { transform: translate(0, 0) rotate(6deg); }
          30%  { transform: translate(-22vw, -30px) rotate(-10deg); }
          60%  { transform: translate(-44vw, -5px) rotate(8deg); }
          100% { transform: translate(-78vw, -25px) rotate(-6deg); }
        }
        @keyframes mdpDrift {
          0%, 100% { transform: translateY(0) rotate(-3deg); }
          50%      { transform: translateY(-8px) rotate(3deg); }
        }
        @keyframes mdpSway {
          0%, 100% { transform: rotate(-4deg); }
          50%      { transform: rotate(4deg); }
        }

        .mothers-day-promo {
          --mdp-pink:        #d97a96;
          --mdp-pink-light:  #f5c8d4;
          --mdp-pink-soft:   #fde6ec;
          --mdp-cream:       #fdf8f0;
          --mdp-gold:        #a8893e;
          --mdp-gold-light:  #d4ba66;
          --mdp-green:       #6a8a4e;
          --mdp-green-light: #9ab97a;
          --mdp-text:        #4a3548;

          position: relative;
          width: 100%;
          min-height: 540px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background:
            radial-gradient(circle at 20% 15%, rgba(245, 200, 212, 0.55) 0%, transparent 40%),
            radial-gradient(circle at 80% 85%, rgba(245, 200, 212, 0.45) 0%, transparent 45%),
            linear-gradient(135deg, #fff5f8 0%, #fde6ec 50%, #fef0f5 100%);
          overflow: hidden;
          font-family: 'Outfit', sans-serif;
        }

        .mothers-day-promo__border {
          position: relative;
          z-index: 2;
          border: 3px solid var(--mdp-gold);
          outline: 1px solid var(--mdp-gold-light);
          outline-offset: 6px;
          background: rgba(253, 248, 240, 0.95);
          padding: 2.25rem 2.25rem 1.5rem;
          max-width: 600px;
          width: 86%;
          text-align: center;
          box-shadow: 0 8px 28px rgba(168, 137, 62, 0.18);
        }

        .mothers-day-promo__icon {
          display: block;
          margin: 0 auto 0.25rem;
          font-size: 2.2rem;
          line-height: 1;
        }

        .mothers-day-promo__title {
          font-family: 'Great Vibes', cursive;
          font-size: 3.4rem;
          color: var(--mdp-pink);
          margin: 0 0 0.5rem;
          line-height: 1.05;
          text-shadow: 1px 1px 0 rgba(168, 137, 62, 0.15);
        }

        .mothers-day-promo__subtitle {
          font-size: 0.95rem;
          font-weight: 600;
          color: var(--mdp-text);
          text-transform: uppercase;
          letter-spacing: 2.5px;
          margin: 0 0 0.4rem;
        }

        .mothers-day-promo__date {
          font-size: 1.05rem;
          font-weight: 700;
          color: var(--mdp-gold);
          margin: 0 0 1.1rem;
          letter-spacing: 1px;
        }

        .mothers-day-promo__divider {
          width: 60px;
          height: 1px;
          background: var(--mdp-gold-light);
          margin: 0 auto 1rem;
          opacity: 0.7;
        }

        .mothers-day-promo__items {
          list-style: none;
          padding: 0;
          margin: 0 0 1rem;
          text-align: left;
        }

        .mothers-day-promo__items li {
          padding: 0.5rem 0;
          border-bottom: 1px dashed rgba(168, 137, 62, 0.25);
        }
        .mothers-day-promo__items li:last-child {
          border-bottom: none;
        }

        .mothers-day-promo__item-head {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          gap: 0.75rem;
          margin-bottom: 0.15rem;
        }

        .mothers-day-promo__item-name {
          font-size: 1rem;
          font-weight: 700;
          color: var(--mdp-text);
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }

        .mothers-day-promo__item-price {
          font-size: 1rem;
          font-weight: 700;
          color: var(--mdp-gold);
          white-space: nowrap;
        }

        .mothers-day-promo__item-desc {
          font-size: 0.85rem;
          color: var(--mdp-text);
          opacity: 0.78;
          line-height: 1.4;
          font-style: italic;
        }

        .mothers-day-promo__cta-group {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.75rem;
          margin-top: 1rem;
        }

        .mothers-day-promo__cta,
        .mothers-day-promo__cta:visited,
        .mothers-day-promo__cta:active {
          display: inline-block;
          background: var(--mdp-pink);
          color: var(--mdp-cream) !important;
          padding: 0.85rem 2.2rem;
          border-radius: 6px;
          font-weight: 700;
          font-size: 1rem;
          text-transform: uppercase;
          letter-spacing: 2px;
          text-decoration: none;
          border: 2px solid var(--mdp-gold);
          transition: background 200ms ease, transform 150ms ease;
        }

        .mothers-day-promo__cta:hover {
          background: var(--mdp-gold);
          color: var(--mdp-cream) !important;
          transform: scale(1.04);
        }

        .mothers-day-promo__menu-link,
        .mothers-day-promo__menu-link:visited,
        .mothers-day-promo__menu-link:active {
          display: inline-block;
          color: var(--mdp-gold) !important;
          font-weight: 600;
          font-size: 0.95rem;
          text-decoration: underline;
          text-underline-offset: 3px;
          transition: color 200ms ease;
        }

        .mothers-day-promo__menu-link:hover {
          color: var(--mdp-pink) !important;
        }

        /* Bottom flower border */
        .mothers-day-promo__flowers {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 80px;
          z-index: 1;
          display: flex;
          justify-content: center;
          gap: 0.85rem;
          pointer-events: none;
          overflow: hidden;
        }

        .mothers-day-promo__flower {
          font-size: 2.6rem;
          animation: mdpSway 3.5s ease-in-out infinite;
          filter: drop-shadow(0 2px 3px rgba(0,0,0,0.08));
          align-self: flex-end;
          padding-bottom: 4px;
        }
        .mothers-day-promo__flower:nth-child(2n)  { animation-delay: 0.4s; font-size: 2.2rem; }
        .mothers-day-promo__flower:nth-child(3n)  { animation-delay: 0.9s; font-size: 2.8rem; }
        .mothers-day-promo__flower:nth-child(5n)  { animation-delay: 1.4s; font-size: 2.4rem; }

        /* Top corner flowers */
        .mothers-day-promo__corner {
          position: absolute;
          font-size: 3.2rem;
          opacity: 0.55;
          z-index: 1;
          pointer-events: none;
          animation: mdpDrift 4s ease-in-out infinite;
          filter: drop-shadow(0 2px 4px rgba(0,0,0,0.08));
        }
        .mothers-day-promo__corner--tl { top: 1.5rem; left: 2rem; }
        .mothers-day-promo__corner--tr { top: 1.5rem; right: 2rem; animation-delay: 1.2s; }

        /* Fluttering butterflies */
        .mothers-day-promo__butterflies {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: 3;
          overflow: hidden;
        }

        .mothers-day-promo__butterfly {
          position: absolute;
          font-size: 1.6rem;
          opacity: 0.6;
          filter: drop-shadow(0 2px 2px rgba(0,0,0,0.1));
        }
        .mothers-day-promo__butterfly--1 {
          bottom: 25%;
          left: -5%;
          animation: mdpFlutter1 16s linear infinite;
        }
        .mothers-day-promo__butterfly--2 {
          top: 18%;
          right: -5%;
          font-size: 1.3rem;
          opacity: 0.45;
          animation: mdpFlutter2 19s linear infinite 2s;
        }
        .mothers-day-promo__butterfly--3 {
          bottom: 45%;
          left: -4%;
          font-size: 1.4rem;
          opacity: 0.4;
          animation: mdpFlutter1 22s linear infinite 6s;
        }

        @media (max-width: 600px) {
          .mothers-day-promo {
            min-height: 460px;
          }
          .mothers-day-promo__border {
            padding: 1.5rem 1.1rem 1.1rem;
            width: 92%;
          }
          .mothers-day-promo__title {
            font-size: 2.4rem;
          }
          .mothers-day-promo__subtitle {
            font-size: 0.78rem;
            letter-spacing: 1.5px;
          }
          .mothers-day-promo__item-name {
            font-size: 0.9rem;
          }
          .mothers-day-promo__item-price {
            font-size: 0.9rem;
          }
          .mothers-day-promo__item-desc {
            font-size: 0.78rem;
          }
          .mothers-day-promo__cta {
            padding: 0.7rem 1.6rem;
            font-size: 0.88rem;
          }
          .mothers-day-promo__corner {
            font-size: 2.2rem;
          }
          .mothers-day-promo__corner--tl { top: 0.75rem; left: 0.75rem; }
          .mothers-day-promo__corner--tr { top: 0.75rem; right: 0.75rem; }
          .mothers-day-promo__flowers {
            height: 60px;
          }
          .mothers-day-promo__flower {
            font-size: 1.9rem;
          }
        }
      `}</style>

      <span className="mothers-day-promo__corner mothers-day-promo__corner--tl" aria-hidden="true">🌸</span>
      <span className="mothers-day-promo__corner mothers-day-promo__corner--tr" aria-hidden="true">🌷</span>

      <div className="mothers-day-promo__butterflies" aria-hidden="true">
        <span className="mothers-day-promo__butterfly mothers-day-promo__butterfly--1">🦋</span>
        <span className="mothers-day-promo__butterfly mothers-day-promo__butterfly--2">🦋</span>
        <span className="mothers-day-promo__butterfly mothers-day-promo__butterfly--3">🦋</span>
      </div>

      <div className="mothers-day-promo__border">
        <span className="mothers-day-promo__icon" aria-hidden="true">💐</span>
        <h2 className="mothers-day-promo__title">Mother&rsquo;s Day Weekend Specials</h2>
        <p className="mothers-day-promo__subtitle">Saturday &amp; Sunday — Open to Close</p>
        <p className="mothers-day-promo__date">May 9 &amp; 10, 2026</p>
        <div className="mothers-day-promo__divider" aria-hidden="true"></div>

        <ul className="mothers-day-promo__items">
          <li>
            <div className="mothers-day-promo__item-head">
              <span className="mothers-day-promo__item-name">Strawberry Pancake Stack</span>
              <span className="mothers-day-promo__item-price">$18.95</span>
            </div>
            <div className="mothers-day-promo__item-desc">
              Four fluffy pancakes layered with house-made strawberry whipped cream, topped with warm strawberry syrup and fresh chopped strawberries.
            </div>
          </li>
          <li>
            <div className="mothers-day-promo__item-head">
              <span className="mothers-day-promo__item-name">Garden Omelette</span>
              <span className="mothers-day-promo__item-price">$19.95</span>
            </div>
            <div className="mothers-day-promo__item-desc">
              A fresh and hearty omelette filled with asparagus, spinach, cherry tomatoes, mushrooms and onions topped with feta cheese. Served with fresh fruit and our tangy arugula salad.
            </div>
          </li>
          <li>
            <div className="mothers-day-promo__item-head">
              <span className="mothers-day-promo__item-name">Prime Rib Plate</span>
              <span className="mothers-day-promo__item-price">$43.95</span>
            </div>
            <div className="mothers-day-promo__item-desc">
              A generous 16 oz slow-roasted prime rib served with your choice of potato and our seasonal vegetable. Includes your choice of homemade soup and house salad, plus our homemade bread pudding topped with warm whiskey sauce.
            </div>
          </li>
          <li>
            <div className="mothers-day-promo__item-head">
              <span className="mothers-day-promo__item-name">Carne Asada Chilaquiles</span>
              <span className="mothers-day-promo__item-price">$24.95</span>
            </div>
            <div className="mothers-day-promo__item-desc">
              Served in a bowl with crispy tortilla chips, juicy carne asada strips, pinto beans, and three eggs any style, topped with your choice of red or green sauce, cotija cheese, sour cream, and fresh cilantro.
            </div>
          </li>
        </ul>

        <div className="mothers-day-promo__cta-group">
          <Link to="/burbank/order" className="mothers-day-promo__cta">
            Order Online
          </Link>
          <a
            href="/lancers-mothers-day-2026.jpeg"
            target="_blank"
            rel="noopener noreferrer"
            className="mothers-day-promo__menu-link"
          >
            View Full Menu Image
          </a>
        </div>
      </div>

      <div className="mothers-day-promo__flowers" aria-hidden="true">
        <span className="mothers-day-promo__flower">🌸</span>
        <span className="mothers-day-promo__flower">🌷</span>
        <span className="mothers-day-promo__flower">🌺</span>
        <span className="mothers-day-promo__flower">🌸</span>
        <span className="mothers-day-promo__flower">🌷</span>
        <span className="mothers-day-promo__flower">🌺</span>
        <span className="mothers-day-promo__flower">🌸</span>
        <span className="mothers-day-promo__flower">🌷</span>
        <span className="mothers-day-promo__flower">🌺</span>
      </div>
    </div>
  );
}
